import React from "react";

const BarChart = ({
  data,
  labelKey = "label",
  valueKey = "value",
  maxValue,
  color = "bg-red-500",
  height = "h-48",
  showValues = true,
}) => {
  if (!data || data.length === 0) {
    return (
      <div className="flex items-center justify-center h-32 text-gray-400 text-sm">
        No data available
      </div>
    );
  }

  const max = maxValue || Math.max(...data.map((d) => d[valueKey]), 1);

  return (
    <div className={`flex items-end gap-1 ${height} px-2`}>
      {data.map((d, i) => (
        <div
          key={i}
          className="flex-1 flex flex-col items-center gap-1 min-w-0"
        >
          {showValues && (
            <span className="text-xs text-gray-600 font-medium">
              {d[valueKey]}
            </span>
          )}
          <div
            className={`w-full ${color} rounded-t transition-all duration-300`}
            style={{
              height: `${(d[valueKey] / max) * 100}%`,
              minHeight: d[valueKey] > 0 ? "4px" : "0px",
            }}
          ></div>
          <span className="text-xs text-gray-500 truncate w-full text-center">
            {d[labelKey]}
          </span>
        </div>
      ))}
    </div>
  );
};

export default BarChart;
